/**
 * Globo #gf-products: always keep product featured image as the card main image.
 */
(function () {
  var LIST_SELECTORS = '#gf-products, #gspfProducts, ul.gf-products, ul[data-gf-products], ul[data-gspf-products]';

  function normalizeImageUrl(url) {
    if (!url || typeof url !== 'string') return '';
    return url
      .replace(/^https?:/i, '')
      .split('?')[0]
      .replace(/_\d+x(\.\w+)(?=($|\?))/i, '$1');
  }

  function isValidProductImageUrl(url) {
    if (!url || typeof url !== 'string') return false;
    if (url.indexOf('data:image/gif') === 0) return false;
    if (url.indexOf('product-1.png') !== -1) return false;
    return /cdn\.shopify\.com|shopify\.com\/s\/files|\/cdn\/shop\//i.test(url);
  }

  function getFeaturedSrc(wrapper, mainImg) {
    if (!wrapper) return '';

    var featuredSrc =
      wrapper.getAttribute('data-mt-featured-src') ||
      wrapper.getAttribute('data-default-image') ||
      '';

    if (!isValidProductImageUrl(featuredSrc) && mainImg) {
      featuredSrc = mainImg.getAttribute('src') || '';
    }

    return featuredSrc;
  }

  function applyFeaturedSrc(mainImg, featuredSrc) {
    if (!mainImg || !isValidProductImageUrl(featuredSrc)) return false;

    var normalizedFeatured = normalizeImageUrl(featuredSrc);
    var normalizedCurrent = normalizeImageUrl(mainImg.currentSrc || mainImg.src || '');

    mainImg.classList.remove('gflazyload');
    mainImg.removeAttribute('data-src');
    mainImg.removeAttribute('data-srcset');
    mainImg.removeAttribute('data-variants');
    mainImg.removeAttribute('srcset');

    if (normalizedCurrent !== normalizedFeatured) {
      mainImg.src = featuredSrc;
      mainImg.setAttribute('src', featuredSrc);
    }

    mainImg.style.setProperty('object-fit', 'contain', 'important');
    mainImg.style.setProperty('object-position', 'center center', 'important');
    mainImg.style.setProperty('width', '100%', 'important');
    mainImg.style.setProperty('height', '100%', 'important');
    mainImg.style.setProperty('max-width', '100%', 'important');
    mainImg.style.setProperty('max-height', '100%', 'important');
    mainImg.setAttribute('data-parent-fit', 'contain');

    return true;
  }

  function hideVariantImages(wrapper, mainImg) {
    wrapper.querySelectorAll('.spf-product-card__image').forEach(function (img) {
      if (img === mainImg) return;
      if (img.classList.contains('spf-product-card__image-secondary')) return;

      img.classList.add('spf-product-card__image-hidden');
      img.style.display = 'none';
      img.style.visibility = 'hidden';
      img.style.opacity = '0';
    });
  }

  function syncVariantOptions(card, featuredSrc) {
    if (!card || !isValidProductImageUrl(featuredSrc)) return;

    card.querySelectorAll('.spf-product__variants option[data-image]').forEach(function (option) {
      option.setAttribute('data-image', featuredSrc);
    });
  }

  function watchMainImage(mainImg, featuredSrc) {
    if (!mainImg || mainImg.__mtFeaturedWatchStarted) return;
    mainImg.__mtFeaturedWatchStarted = true;

    var normalizedFeatured = normalizeImageUrl(featuredSrc);

    var observer = new MutationObserver(function () {
      var normalizedCurrent = normalizeImageUrl(mainImg.currentSrc || mainImg.src || '');
      if (normalizedCurrent && normalizedCurrent !== normalizedFeatured) {
        applyFeaturedSrc(mainImg, featuredSrc);
      }
    });

    observer.observe(mainImg, {
      attributes: true,
      attributeFilter: ['src', 'srcset', 'class', 'style']
    });
  }

  function showMainImage(wrapper, mainImg, card) {
    if (!wrapper || !mainImg) return;

    var featuredSrc = getFeaturedSrc(wrapper, mainImg);
    if (!applyFeaturedSrc(mainImg, featuredSrc)) return;

    mainImg.classList.add('spf-product-card__image-main', 'lazyloaded');
    mainImg.classList.remove('spf-product-card__image-hidden');
    mainImg.style.removeProperty('opacity');
    mainImg.style.removeProperty('visibility');
    mainImg.style.removeProperty('display');

    hideVariantImages(wrapper, mainImg);
    syncVariantOptions(card, featuredSrc);
    watchMainImage(mainImg, featuredSrc);
  }

  function enforceCard(wrapper) {
    if (!wrapper) return;

    var card = wrapper.closest('.spf-product-card');
    var mainImg = wrapper.querySelector('.spf-product-card__image-main');

    if (!mainImg) {
      mainImg = wrapper.querySelector('img.spf-product-card__image:not(.spf-product-card__image-secondary)');
      if (mainImg) mainImg.classList.add('spf-product-card__image-main');
    }

    if (!mainImg) return;

    showMainImage(wrapper, mainImg, card);
  }

  function enforceFeaturedMainImages(root) {
    var scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll(LIST_SELECTORS).forEach(function (list) {
      list.querySelectorAll('.spf-product-card__image-wrapper').forEach(enforceCard);
    });
  }

  function observeGloboLists() {
    document.querySelectorAll(LIST_SELECTORS).forEach(function (list) {
      if (list.__mtGfFeaturedImageObserved) return;
      list.__mtGfFeaturedImageObserved = true;

      var observer = new MutationObserver(function () {
        window.requestAnimationFrame(function () {
          enforceFeaturedMainImages(list);
        });
      });

      observer.observe(list, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['src', 'srcset', 'class', 'style']
      });
    });
  }

  function boot() {
    enforceFeaturedMainImages(document);
    observeGloboLists();
    [300, 800, 1500, 3000, 5000].forEach(function (delay) {
      window.setTimeout(enforceFeaturedMainImages, delay);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('globoFilterUpdated', boot);
  window.addEventListener('load', boot);
})();
